import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Container, Grid, Image, Stack, Text } from '@mantine/core';
import { LoginBg } from '@/assets/login';
import { useAuthStore } from '@/stores/auth-store';

export const Route = createFileRoute('/(auth)/_auth')({
  component: PathlessLayoutComponent,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState();
    if (isAuthenticated()) {
      return redirect({ to: '/attendance' });
    }
  },
});

function PathlessLayoutComponent() {
  return (
    <Container fluid p={0} h="100vh" style={{ overflow: 'hidden' }}>
      <Grid columns={24} gutter={0} overflow="hidden" grow>
        <Grid.Col span={{ base: 0, md: 12, lg: 14 }} bg="primary" visibleFrom="md" h="100vh">
          <Stack align="center" justify="center" h="100%" gap={56}>
            <Image loading="lazy" src={LoginBg} style={{ width: 600 }} />

            <Text c="#FFF" fw={400} maw={304} ta="center">
              Manajemen sumber daya manusia lebih Professional
            </Text>
          </Stack>
        </Grid.Col>

        <Grid.Col span={{ base: 24, md: 12, lg: 10 }} pt={120}>
          <Outlet />
        </Grid.Col>
      </Grid>
    </Container>
  );
}
